export const RETURNS_ADDRESSES_FETCH_ALL = 'RETURNS_ADDRESSES_FETCH_ALL'
export const RETURNS_FETCH_ALLOWED_METHODS = 'RETURNS_FETCH_ALLOWED_METHODS'
export const RETURNS_FETCH_DEFAULTS = 'RETURNS_FETCH_DEFAULTS'
export const RETURNS_FETCH_DETAILS = 'RETURNS_FETCH_DETAILS'
export const RETURNS_FETCH_STATIC_DATA = 'RETURNS_FETCH_STATIC_DATA'
